import { render, staticRenderFns } from "./BaseStyle.vue?vue&type=template&id=97164ab4&scoped=true"
import script from "./BaseStyle.vue?vue&type=script&lang=js"
export * from "./BaseStyle.vue?vue&type=script&lang=js"
import style0 from "./BaseStyle.vue?vue&type=style&index=0&id=97164ab4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97164ab4",
  null
  
)

export default component.exports